module.exports = __webpack_public_path__ + "img/Picture32.a0f81e42.png";